import { useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import CustomCss from "../../../components/BuilderComponents/CustomCss";
import FieldFormatSelection from "../../../components/BuilderComponents/FieldFormateSelection";
import { columnOperatorData, operatorData } from "../../../components/BuilderComponents/PreFilters/operatorData";
import ValueAccordingOperator from "../../../components/BuilderComponents/PreFilters/ValueAccordingOperator";
import { AddAndDeleteInlineIcon } from "../../../components/BuilderComponents/Preview/IconPreview";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import Button from "../../../components/FormComponents/Button";
import Input from "../../../components/FormComponents/Input";
import Label from "../../../components/FormComponents/Label";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import { useTableContext } from "../../../context/TableContext";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { hasOwn } from "../../../commonFunctions/arrayFunc";
import { generateObjectId } from "../../../utils/objectIdUtils";

const BlockTitles = ({ tiles, setTiles, allTableColumns, table_id, activity_id = "" }) => {
  // const [isModalOpen, setIsModalOpen] = useState(null);

  if (!tiles) {
    tiles = [];
  }

  const handleChangeSingletile = (newTile, index) => {
    const copyTiles = [...tiles];
    copyTiles[index] = newTile;
    setTiles(copyTiles);
  };

  const addTiles = () => {
    setTiles([
      ...tiles,
      {
        title: "New tile",
        id: generateObjectId(),
        aggregate_column: "",
        aggregate_config: {
          operator: "",
          // value: "",
          group_by_column: ""
        },
        icon: "",
        aggregate_function: "",
        format_type: "",
        custom_css: "",
        custom_id: "",
        custom_classname: ""
      }
    ]);
  };
  const folderIds = activity_id ? [activity_id] : [];
  return (
    <div className="tab_inside_container">
      <div className="w_100">
        <Button className="ml_auto mb_2" onClick={addTiles} variant="secondary">
          <MaterialIcon name="add" style={{ fontSize: "17px", marginRight: "4px" }} /> Tile
        </Button>
      </div>

      <ReactSortable
        handle=".Recordsviewfielddragclass"
        list={tiles}
        setList={(list) => setTiles(list)}
        animation="200"
        easing="ease-out"
      >
        {tiles?.map((tile, index) => (
          <div key={tile.id} className="builder_tiles field_card" style={{ padding: "0px", marginBottom: "20px" }}>
            <div className="d_flex mb_2 pt_2">
              <MaterialIcon
                name="drag_indicator"
                className="Recordsviewfielddragclass drag_icon font_size_xlarge cursor_grab"
              />
            </div>

            <EditSingleTileOfBlock
              tile={tile}
              handleChangeSingletile={(newTile) => handleChangeSingletile(newTile, index)}
              tableId={table_id}
              folderIds={[folderIds]}
              tableObj={allTableColumns}
              // tableType={tableType}
            />

            <ButtonActionIcon
              type="delete"
              className="tiles_remove_btn"
              onClick={() => setTiles(tiles.filter((t, i) => i !== index))}
            />
          </div>
        ))}
      </ReactSortable>
    </div>
  );
};

const aggregateOptions = [
  { id: "avg", name: "avg" },
  { id: "sum", name: "sum" },
  { id: "count", name: "count" },
  { id: "unique_count", name: "unique count" },
  { id: "sum_if", name: "sum if" },
  { id: "count_if", name: "count if" }
];

const EditSingleTileOfBlock = ({ tile, handleChangeSingletile, tableId, folderIds, tableObj, tableType }) => {
  const handleCustomCss = (e) => {
    const { name, value } = e.target;
    const newTile = { ...tile };
    newTile[name] = value;
    handleChangeSingletile(newTile);
  };

  return (
    <>
      <BuilderTabs
        tabs={[
          {
            label: "Basic",
            content: (
              <EditRecordviewTile
                tile={tile}
                handleChangeSingletile={handleChangeSingletile}
                tableId={tableId}
                folderIds={folderIds}
                tableObj={tableObj}
                tableType={tableType}
              />
            )
          },
          {
            label: "Advanced",
            content: (
              <div className="p_3 flex_column gap_3">
                <CustomCss
                  value={{
                    custom_css: tile.custom_css || "",
                    custom_id: tile.custom_id || "",
                    custom_classname: tile.custom_classname || ""
                  }}
                  onChange={handleCustomCss}
                />
              </div>
            )
          }
        ]}
      />
    </>
  );
};

const EditRecordviewTile = ({ tile, handleChangeSingletile, tableId, folderIds, tableType }) => {
  const [selectedIcon, setSelectedIcon] = useState(tile.icon || "");
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();

  const handleAggrigateColumn = (data) => {
    const newTile = { ...tile, aggregate_column: data.id };
    handleChangeSingletile(newTile);
    setIsModalOpen(false);
  };

  const handleUpdateIcon = (data) => {
    const newTile = { ...tile };
    newTile.icon = data;
    setSelectedIcon(data);
    handleChangeSingletile(newTile);
  };

  const handleInputChange = (name, value) => {
    const newTile = { ...tile };
    newTile[name] = value;
    if (name === "aggregate_function") {
      newTile.aggregate_config = {
        operator: "",
        group_by_column: ""
      };
    }
    handleChangeSingletile(newTile);
  };

  const handleTileGroupUpdate = (newTile) => {
    handleChangeSingletile(newTile);
  };

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="flex_column gap_3 p_3">
      <div className="flex_column gap_2">
        <Label className="">Title</Label>
        <div className="d_flex">
          <AddAndDeleteInlineIcon icon={selectedIcon} callbackFunction={handleUpdateIcon} />
          <Input
            inputClassName="border_left_none"
            name="title"
            value={tile?.title}
            inputBoxStyle={{ outline: "none" }}
            onChange={(e) => handleInputChange("title", e.target.value)}
          />
        </div>
      </div>
      <FieldFormatSelection
        type="number"
        value={tile.format_type || ""}
        onChange={(id) => handleInputChange("format_type", id)}
      />
      <FieldFormatSelection
        type="currency"
        value={tile.currency_code || ""}
        onChange={(id) => handleInputChange("currency_code", id)}
        label="Currency Format"
      />
      <div className="flex_column gap_2">
        <Label className="builder_label">Aggregate Column</Label>
        <div className="builder_input cursor_pointer" onClick={() => setIsModalOpen(true)}>
          <div className="d_flex justify_center align_center">
            {tile.aggregate_column === ""
              ? "No field assign"
              : (tableObj[tile.aggregate_column]?.prefix || "") + "." + tableObj[tile.aggregate_column]?.display}
          </div>
        </div>
      </div>

      <SingleSelectBox
        selectedData={tile.aggregate_function}
        options={aggregateOptions}
        onChange={(obj) => handleInputChange("aggregate_function", obj.id)}
        placeholder="none"
        label="Aggregate Function"
      />

      {(tile.aggregate_function === "sum_if" || tile.aggregate_function === "count_if") && (
        <GroupData
          tile={tile}
          updateTiles={handleTileGroupUpdate}
          tableObj={tableObj}
          tableId={tableId}
          folderIds={folderIds}
          operatorList={[...operatorData, ...columnOperatorData]}
        />
      )}
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName={"Add Aggregate Column"}>
        <TableTreeModal
          callbackFunction={handleAggrigateColumn}
          tableId={tableId}
          selectedFile={tableObj && tile?.aggregate_column ? tableObj[tile.aggregate_column]?.id : ""}
        />
      </BuilderModal>
    </div>
  );
};

const GroupData = ({ tile, updateTiles, tableObj, tableId, operatorList }) => {
  const [isGroupOpen, setIsGroupOpen] = useState(null);
  const [operatorListForType, setOperatorListForType] = useState([]);

  const handleGroupColumn = (data) => {
    const newTile = { ...tile };
    const aggConfig = { ...newTile.aggregate_config, group_by_column: data.id };
    newTile.aggregate_config = aggConfig;
    updateTiles(newTile);
    setIsGroupOpen(null);
  };

  const getOperatorList = () => {
    const field = tableObj[tile.aggregate_config?.group_by_column];
    if (field) {
      const operatorArray = operatorList.filter((op) => op.fields.includes(field.field_type || field.type));
      setOperatorListForType(operatorArray);
    }
  };

  const handleChangeValue = (type, value) => {
    const newTile = { ...tile, aggregate_config: { ...tile.aggregate_config } };

    newTile.aggregate_config[type] = type === "number_value" ? parseInt(value) : value;

    if (type === "operator") {
      const newObj = removeObjectKeys(newTile.aggregate_config);
      newTile.aggregate_config = newObj;
    }

    updateTiles(newTile);
  };

  const removeObjectKeys = (obj) => {
    const newObj = JSON.parse(JSON.stringify(obj));
    const keysToDelete = [
      "text_value",
      "number_value",
      "number_range",
      "human_date",
      "custom_date_range",
      "text_array"
    ];
    keysToDelete.forEach((key) => {
      if (hasOwn(newObj, key)) {
        delete newObj[key];
      }
    });

    return newObj;
  };

  useEffect(() => {
    getOperatorList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tile, tableObj]);
  return (
    <>
      <div className="flex_column gap_2">
        <Label className="builder_label">Group By Column</Label>
        <div className="builder_input" onClick={() => setIsGroupOpen(true)}>
          <div className="d_flex justify_center align_center">
            {tile?.aggregate_config?.group_by_column
              ? (tableObj[tile.aggregate_config.group_by_column]?.prefix || "") +
                "." +
                tableObj[tile.aggregate_config.group_by_column]?.display
              : "No field assign"}
          </div>
        </div>
      </div>

      {tile?.aggregate_config?.group_by_column && (
        <div>
          <SingleSelectBox
            selectedData={tile?.aggregate_config?.operator}
            options={operatorListForType}
            valueKey="operator"
            labelKey={["operator_name"]}
            onChange={(obj) => handleChangeValue("operator", obj.operator)}
            placeholder="Select operator"
            label="Operator"
          />
        </div>
      )}

      {tile.aggregate_config.operator && (
        <div className="flex_column gap_2">
          <Label className="builder_label">Value</Label>
          <ValueAccordingOperator
            value={operatorListForType.find((op) => op.operator === tile.aggregate_config.operator)?.value}
            updatePrefilter={handleChangeValue}
            field={{ ...tile?.aggregate_config, id: tile?.aggregate_config?.group_by_column }}
            // allAppuserData={allAppuserData}
            tableId={tableId}
          />
        </div>
      )}

      <BuilderModal isOpen={isGroupOpen} onClose={() => setIsGroupOpen(false)} modalName={"Add Group By Column"}>
        <TableTreeModal
          callbackFunction={handleGroupColumn}
          tableId={tableId}
          selectedFile={
            tableObj && tile?.aggregate_config?.group_by_column
              ? tableObj[tile.aggregate_config.group_by_column]?.id
              : ""
          }
        />
      </BuilderModal>
    </>
  );
};

export default BlockTitles;
export { EditRecordviewTile, EditSingleTileOfBlock };
